export const fragenAutoAbmelden = [
  {
    question: "Kann ich mein Auto abmelden, wenn es noch finanziert ist?",
    answer: (
      <>
        <p>
          Ja, das ist grundsätzlich möglich. Wenn das Auto jedoch durch den
          Kreditgeber als Sicherheit dient, musst du vorher dessen Zustimmung
          einholen.
        </p>
      </>
    ),
  },
  {
    question: "Was muss ich der Versicherung nach der Abmeldung melden?",
    answer: (
      <>
        <p>
          Mit der Abmeldung endet die Zulassung des Fahrzeugs. Halte trotzdem
          Rücksprache mit deiner Kfz-Versicherung, ab welchem Tag der Vertrag
          ruht oder endet und wie bereits bezahlte Prämien behandelt werden. Die
          Abmeldebestätigung ist dabei dein Nachweis – hebe sie auf.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich mein Auto in Österreich online abmelden?",
    answer: (
      <>
        <p>
          Nein. Eine reine Online-Abmeldung gibt es in Österreich nicht – auch
          nicht mit ID Austria. Die Unterlagen und die Kennzeichentafeln müssen
          einer Zulassungsstelle vorgelegt werden. Mit einer schriftlichen
          Vollmacht kann das aber jemand anderer für dich erledigen.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich die Kennzeichentafeln abgeben?",
    answer: (
      <>
        <p>
          Ja, bei der Abmeldung gibst du die Kennzeichentafeln ab. Willst du
          dein Kennzeichen für ein anderes Fahrzeug behalten, kannst du im Zuge
          der Abmeldung die Freihaltung beantragen – längstens für zwölf Monate.
          Das neue Fahrzeug musst du dann bei derselben Zulassungsstelle
          anmelden, bei der du abgemeldet hast. Wenn du das Fahrzeug dagegen nur
          vorübergehend nicht nutzt, ist die Hinterlegung der Kennzeichentafeln
          der passende Weg statt einer Abmeldung: bis zu einem Jahr möglich und
          gebührenfrei – hol sie aber vor Ablauf des Jahres wieder ab oder lass
          die Hinterlegung verlängern, sonst erlischt die Zulassung.
        </p>
      </>
    ),
  },
  {
    question: "Was passiert, wenn ich mein Auto nicht abmelde?",
    answer: (
      <>
        <p>
          Wenn du ein nicht genutztes Fahrzeug nicht abmeldest, laufen
          Versicherung und Steuer weiter. Zudem drohen Strafen, wenn das Fahrzeug
          ohne gültige Zulassung im öffentlichen Raum steht.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich mein Auto nach der Abmeldung wieder anmelden?",
    answer: (
      <>
        <p>
          Ja, jederzeit. Du benötigst dafür die üblichen Unterlagen. Dein altes
          Kennzeichen kannst du wiederverwenden, wenn du es im Zuge der
          Abmeldung freihalten hast lassen (längstens zwölf Monate) – die
          Anmeldung des neuen Fahrzeugs muss dann bei derselben Zulassungsstelle
          erfolgen, bei der du das alte abgemeldet hast.
        </p>
      </>
    ),
  },
];

